export const container = "c1t3ouff";
export const heading = "h1901wo6";
export const playIcon = "pqo72n0";

require("./style.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");